module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-MediumOblique-91c806a10a2bc210622caf66b856ed21.svg";